import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Break from '../../../../assets/icons/Break';
import PlusThin from '../../../../assets/icons/PlusThin';
import AddItemMenu from './AddItemMenu';

interface AddItemActionsProps {
    onAddItem: () => void;
    onAddBreak?: () => void;
    disableBreak?: boolean;
}

function AddItemActions({onAddItem, onAddBreak, disableBreak}: AddItemActionsProps) {
    const {t} = useTranslation('timetable');
    return (
        <>
            <AddItemMenu
                text={t('addItem')}
                variant="brand"
                placement="above"
                iconStart={<PlusThin />}
                onAddLecture={onAddItem}
                onAddBreak={onAddBreak}
                disableBreak={disableBreak}
            />
            {(onAddBreak || disableBreak) && (
                <Button variant="neutral" size="chip" iconStart={<Break />} onClick={onAddBreak} disabled={disableBreak} data-cy="timetable-add-break">
                    {t('addBreak')}
                </Button>
            )}
        </>
    );
}

export default AddItemActions;
